import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Lightbulb, MessageSquare, MessageSquareHeart } from "lucide-react";
import { cn } from "@/lib/utils";

type MarketingTextAnalysisDemoProps = {
  className?: string;
};

const demoFeedback = {
  excerpt: "Arcitext helps you write copy for any purpose without losing your writing style.",
  score: "Excellent fit",
  scoreTone: "bg-emerald-500",
  suggestions: [
    {
      id: 1,
      text: "Align text better with the brand's creator archetype.",
    },
    {
      id: 2,
      text: "Use words from the brand word list to improve uniqueness.",
    },
    {
      id: 3,
      text: "Address the target audience's pain points.",
    },
  ],
};

export const MarketingTextAnalysisDemo = ({ className }: MarketingTextAnalysisDemoProps) => {
  return (
    <Card className={cn("max-w-xl", className)}>
      <CardHeader>
        <CardTitle className="flex items-center justify-between gap-2 text-base font-semibold">
          <span className="flex items-center gap-2">
            <MessageSquareHeart className="h-4 w-4" />
            Tone of Voice analysis
          </span>
          <Badge className={cn("text-white", demoFeedback.scoreTone)}>{demoFeedback.score}</Badge>
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-5">
        <div className="rounded-lg border border-border/80 bg-muted/30 px-3 py-2 text-sm text-muted-foreground">
          “{demoFeedback.excerpt}”
        </div>

        <div className="rounded-lg border border-dashed border-border/70 bg-background/80 p-4">
          <p className="text-xs uppercase tracking-wide text-muted-foreground">Suggestions</p>
          <ul className="mt-3 space-y-2">
            {demoFeedback.suggestions.map((suggestion) => (
              <li key={suggestion.id} className="grid grid-cols-[auto_1fr] gap-2 text-sm text-foreground">
                <Lightbulb className="h-4 w-4 mt-1 text-primary" />
                <span>{suggestion.text}</span>
              </li>
            ))}
          </ul>
        </div>
      </CardContent>
    </Card>
  );
};

export default MarketingTextAnalysisDemo;
